import React, { memo, useEffect, useState } from 'react';
import { Button, Input, Select, SelectItem } from "@heroui/react";

import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { ScopeOptions } from '../../filterTypes';

export interface ISelectionSaveProps {
    label: string;
    name?: string;
    selectedOption?: string;
    // setSelectedOption: (value: string) => void;
    // setName: (value: string) => void;
    register: UseFormRegister<any>;
    errors: FieldErrors<any>;
    isEditAllowed: boolean;
    onSubmit: () => void;
    filterNames: string[] | null;
}


export const SelectionSave: React.FC<ISelectionSaveProps> = memo(({ ...props }) => {

    const [name, setName] = useState<string>(props.name || '');
    const [selectedOption, setSelectedOption] = useState<string>(props.selectedOption || '');
    const [errors, setErrors] = useState<FieldErrors<any>>();

    useEffect(() => {
        setName(props.name || '');
        setSelectedOption(props.selectedOption || '');
    }, [props.name, props.selectedOption]);

    useEffect(() => {
        setErrors(props.errors);
    }, [props.errors]);

    const renderNameInput = () => {

        return (<div className="flex-none ">
            <Input
                {...props.register('name', {
                    required: 'Name is required',
                    validate: {
                        shouldHaveUniqueName: value => (!props.filterNames?.includes(value) || 'Name already exists')
                    }
                }
                )}
                size="sm"
                aria-label="name-input"
                isDisabled={!props.isEditAllowed}
                className={errors?.name?.message && errors.name.message.toString().length > 0 ? 'border-msi-chart-red' : ''}
                classNames={{
                    label: "text-sm font-semibold text-msi-midblue-color-500",
                    inputWrapper: "w-48 rounded",
                    errorMessage: "text-red-500 text-xs"
                }}
                type="text"
                placeholder="Name..."
                label={props.label}
                labelPlacement="outside-left"
                value={name}
                onValueChange={(value) => setName(value)}
            />
            {errors?.name && <span className="text-red-500 text-xs">{errors.name.message?.toString()}</span>}
        </div>)
    };

    const renderScopeSelect = () => {
        const scopeOptions = Object.values(ScopeOptions);
        return (
            <div className="flex-none">
                <Select
                    {...props.register('scope', { required: 'Scope is required' })}
                    size="sm"
                    aria-label='scope-select'
                    isDisabled={!props.isEditAllowed}
                    selectionMode="single"
                    placeholder="Select Scope"
                    disallowEmptySelection
                    classNames={{
                        mainWrapper: "w-48 mr-4",
                        label: "text-sm font-semibold text-msi-midblue-color-500 pt-1",
                        trigger: "rounded",
                        popoverContent: "rounded"
                    }}
                    selectedKeys={selectedOption ? [selectedOption] : []}
                    onSelectionChange={(keys) => setSelectedOption(Array.from(keys)[0] as string)}
                >
                    {scopeOptions.map((item) => (
                        <SelectItem aria-label={item} hideSelectedIcon key={item} classNames={{ base: "rounded" }}>
                            {item}
                        </SelectItem>
                    ))}
                </Select>
                {errors?.scope  && <span className="text-red-500 text-xs">{errors.scope.message?.toString()}</span>}
            </div>
        );
    };

    const renderSaveButton = () => (
        <div className="flex-initial">
            <Button onPress={props.onSubmit} aria-label='save-button' size="sm" type='button' className="bg-msi-chart-midgreen text-white rounded">Save</Button>
        </div>
    );

    return (
        <>
            {renderNameInput()}
            {renderScopeSelect()}
            {renderSaveButton()}
        </>
    );
});

export default SelectionSave;